// De dónde sale un remoto.
//
// Its own module, with NO imports, for two reasons. It is the piece with a rule
// that is easy to get subtly wrong, so it is the piece that needs a test — and
// `kinds.js` next door pulls in the icon components, which makes it JSX all the
// way down and unreachable from `node --test`.
//
// Read off the HOST and not with `includes('github')`: a remote at
// `https://git.empresa.com/github-migration/repo.git` contains the word and is
// not GitHub, and that is the kind of wrong badge nobody double-checks.
export function hostOf(remote) {
    if (!remote) return null;

    // Two shapes reach this column, and only one of them is a URL:
    //   https://github.com/org/repo.git
    //   git@github.com:org/repo.git
    const ssh = /^[^@\s]+@([^:\s]+):/.exec(String(remote).trim());
    if (ssh) return ssh[1].toLowerCase();

    try {
        return new URL(String(remote).trim()).hostname.toLowerCase();
    } catch {
        return null;
    }
}

// Only GitHub gets a mark, and only because it is the only host this panel has
// a glyph for. A generic «repo» icon on every remote would say nothing; an
// invented GitLab or Bitbucket mark would be a shape nobody recognises. The
// rule is: mark what we can name, and leave the rest as the URL, which is what
// somebody copies anyway.
export function isGithub(remote) {
    const host = hostOf(remote);
    return host === 'github.com' || host === 'www.github.com';
}
